var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "mr-[13.5px]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35366 10.6465C6.40011 10.693 6.43696 10.7481 6.4621 10.8088C6.48724 10.8695 6.50018 10.9346 6.50018 11.0003C6.50018 11.066 6.48724 11.131 6.4621 11.1917C6.43696 11.2524 6.40011 11.3076 6.35366 11.354C6.3072 11.4005 6.25205 11.4373 6.19135 11.4625C6.13066 11.4876 6.0656 11.5006 5.99991 11.5006C5.93421 11.5006 5.86915 11.4876 5.80846 11.4625C5.74776 11.4373 5.69261 11.4005 5.64615 11.354L0.646155 6.35403C0.599667 6.30759 0.562787 6.25245 0.537625 6.19175C0.512463 6.13105 0.499512 6.06599 0.499512 6.00028C0.499512 5.93457 0.512463 5.86951 0.537625 5.80881C0.562787 5.74811 0.599667 5.69296 0.646155 5.64653L5.64615 0.646528C5.73997 0.552708 5.86722 0.5 5.99991 0.5C6.13259 0.5 6.25984 0.552708 6.35366 0.646528C6.44748 0.740348 6.50018 0.867596 6.50018 1.00028C6.50018 1.13296 6.44748 1.26021 6.35366 1.35403L1.70678 6.00028L6.35366 10.6465Z",
    fill: "#748181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3ccc45d8977533a2825ae16fee9a10ef.svg";
export { ForwardRef as ReactComponent };